import EditLearnerPage from './EditLearnerPage';
export default EditLearnerPage;
